import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* createMerchant({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.store_domains.create, data: values });

    onSuccess();
    yield put(actions.createMerchantDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createMerchantFailed,
      handledErrors,
      endpoint: api.store_domains.create.url
    });
  }
}

export const createMerchantSaga = takeEvery(types.CREATE_MERCHANT_REQUEST, createMerchant);